import { useCallback } from 'react';
import { useRouter } from 'next/router';
import qs from 'qs';

import { useSetListType } from 'Stores/ListStore/ListStore';
import { useResetListPosition } from 'Stores/VehicleListPositionStore/VehicleListPositionStore';
import { DEFAULT_VEHICLE_LIST_ROUTE } from 'Utilities/consts';

import type { SimilarVehiclesEvents } from '../SimilarVehicles/SimilarVehicles';

type UseOnSeeAllVehiclesLinkClick = () => void;
export interface UseOnSeeAllVehiclesLinkClickProps {
	normalisedMake?: string;
	normalisedModel?: string;
	onSeeAllVehiclesLinkClick?: SimilarVehiclesEvents['onViewAllVehiclesClick'];
	shouldUseMakeAndModelFilter?: boolean;
}

export const useOnSeeAllVehiclesLinkClick = ({
	normalisedMake,
	normalisedModel,
	onSeeAllVehiclesLinkClick,
	shouldUseMakeAndModelFilter,
}: UseOnSeeAllVehiclesLinkClickProps): UseOnSeeAllVehiclesLinkClick => {
	const setListType = useSetListType();
	const resetListPosition = useResetListPosition();
	const router = useRouter();

	return useCallback(async () => {
		const makeAndModelQuery = qs.stringify(
			shouldUseMakeAndModelFilter ? { make: normalisedMake, model: normalisedModel } : { make: normalisedMake },
		);
		const href = `${DEFAULT_VEHICLE_LIST_ROUTE.href}&${makeAndModelQuery}`;
		const as = `${DEFAULT_VEHICLE_LIST_ROUTE.as}&${makeAndModelQuery}`;

		onSeeAllVehiclesLinkClick?.(as);
		setListType('auction');
		resetListPosition();

		await router.push(href, as);
	}, [
		normalisedMake,
		normalisedModel,
		router,
		setListType,
		shouldUseMakeAndModelFilter,
		resetListPosition,
		onSeeAllVehiclesLinkClick,
	]);
};
